/* eslint-disable @next/next/no-img-element */
"use client";

import DefaultPageLayout from "@/layouts/DefaultPageLayout";
import { Fragment, Suspense, useEffect, useRef, useState } from "react";
import { useGlobalData } from "@/contexts/GlobalData";
import DetailPageLayout from "@/layouts/DetailPageLayout";
import { InputOtp } from "@nextui-org/input-otp";
import { useAuth } from "@/contexts/Auth";
import Link from "next/link";
import PageHeader from "../PageHeader";
import ConfirmClaim from "../ComfirmClaim";
import { useRouter } from "next/navigation";
import confirmOTPClaimService from "@/services/comfirmOtpClaimService";
import { ButtonStatus } from "../PrimaryButton";
const prefix = "forgot_password_";
export default function ForgotPassword() {
  const [password, setPassword] = useState("");
  const {
    translate,
    runEffectNavigation
  } = useGlobalData();
  const {
    setLoginAppStep,
    token
  } = useAuth();
  const router = useRouter();
  const [confirmStatus, setConfirmStatus] = useState<ButtonStatus>("normal");
  const [errorConfirmMessage, setErrorConfirmMessage] = useState("");
  const handleConfirm = (otp: string) => {
    setConfirmStatus("loading");
    try {
      confirmOTPClaimService(otp, "reset-password", token, async data => {
        if (data.success) {
          setConfirmStatus("success");
          setTimeout(() => {
            setConfirmStatus("normal");
          }, 2000);
          setLoginAppStep("change-password");
          localStorage.removeItem("failedLoginTimes");
          localStorage.removeItem("loginLockedUntil");
          return;
        }
        setErrorConfirmMessage(data?.message);
        setConfirmStatus("error");
        setTimeout(() => {
          setConfirmStatus("normal");
        }, 2000);
      });
    } catch (error) {
      setConfirmStatus("error");
      setErrorConfirmMessage("error");
      setTimeout(() => {
        setConfirmStatus("normal");
      }, 2000);
    }
  };
  return <DetailPageLayout header={<PageHeader overrideBackAction={() => {
    setLoginAppStep("login");
    runEffectNavigation();
  }}>
                    {translate(prefix + "forgot password")}
                </PageHeader>} data-sentry-element="DetailPageLayout" data-sentry-component="ForgotPassword" data-sentry-source-file="page.tsx">
            <DefaultPageLayout className="flex flex-col gap-3 flex-1 !pb-8" data-sentry-element="DefaultPageLayout" data-sentry-source-file="page.tsx">
                <ConfirmClaim alwayFocus hideDivider amount={0} autoSendCodeToEmail
      // autoSubmit
      claimType={"reset-password"} claimStatus={confirmStatus} handleClaim={handleConfirm} errorMessage={errorConfirmMessage} setErrorMessage={setErrorConfirmMessage} className="flex-1 " buttonClassName="mt-6 mb-auto" boardClassName="flex-1 !gap-3" data-sentry-element="ConfirmClaim" data-sentry-source-file="page.tsx" />
            </DefaultPageLayout>
        </DetailPageLayout>;
}